import { Team } from './../shared/domain/team';
import { HttpConnectorAdapter } from './../adapters/http-connector-adapter';
import { UserFull } from '../models/user';

export default class TeamProvider {
    private endpointAdmin: string;

    constructor() {
        this.endpointAdmin = `${process.env.REACT_APP_ADMIN_TOOL_API}team/`;
    };

    init = () => {
        return HttpConnectorAdapter;
    };

    getTeamInfoById = (teamId: string) => {
        return this.init().getWithCredentials(`${this.endpointAdmin}${teamId}`).then(response => {
            const team = response.data as Team;
            const accountId = team.accounts[0];
            return { accountId };
        });
    }

    fetchTeamFromTeamId = (teamId: string) => {
        return this.init().getWithCredentials(`${this.endpointAdmin}${teamId}`).then(response => {
            return response.data as Team;
        });
    }

    fetchTeamUsers = (teamId: string) => {
        return this.init().getWithCredentials(`${this.endpointAdmin}users/${teamId}`).then(response => {
            const statusCode = response.status;

            return { status: statusCode, users: response.data as UserFull[] };
        });
    }

    updateTeam = (teamId: string, team: Team) => {
        delete team['_rev'];
        delete team['_sync'];
        const headers = { 'Content-Type': 'application/json' };
        return this.init().putWithCredentials(`${this.endpointAdmin}/${teamId}`, JSON.stringify(team), headers).then(response => {
            const statusCode = response.status;

            return { status: statusCode, team: response.data as Team };
        });
    }

    createTeam = (team: Team) => {
        const formattedTeam: any = team;
        delete formattedTeam['team_id'];
        delete formattedTeam['timestamp'];
        const headers = { 'Content-Type': 'application/json' };
        return this.init().postWithCredentials(`${this.endpointAdmin}`, JSON.stringify(formattedTeam), headers).then(response => {
            const statusCode = response.status;

            return { status: statusCode, team: response.data as Team };
        });
    }
}